import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import AuthShell from "@/components/AuthShell";
import { CheckCircle, XCircle } from "@phosphor-icons/react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setStatus("ok"))
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <AuthShell title="Vérification de l'email" footer={<Link to="/app" className="text-accent hover:underline">Accéder à interKO</Link>}>
      <div className="surface rounded-md p-8 flex flex-col items-center text-center" data-testid="verify-status">
        {status === "loading" && <div className="text-muted animate-pulse">Vérification en cours…</div>}
        {status === "ok" && (<><CheckCircle size={48} className="text-accent mb-3" weight="fill" /><p className="text-fg">Votre email est confirmé.</p></>)}
        {status === "error" && (<><XCircle size={48} className="text-destructive mb-3" weight="fill" /><p className="text-muted">Lien de vérification invalide ou expiré.</p></>)}
      </div>
    </AuthShell>
  );
}
